import { LoggerStrategies } from 'src/app/constants/log';
import { AppEnvironment } from './environment.model';

const keycloak = {
  url: 'https://auth.omicronlab.com.mx/auth',
  realm: 'omicron',
  clientId: 'omicron-dxp',
};
export const conekta = {
  publicKey: 'key_cPY6JYi6fSFYhg1QqapQxXw',
};
const loggerStrategy = LoggerStrategies.GOOGLE;
const firebase = {
  apiKey: "AIzaSyBy94xkesglHEteAGqgnRketG_t11osh8Y",
  authDomain: "omicronlab-dxp.firebaseapp.com",
  projectId: "omicronlab-dxp",
  storageBucket: "omicronlab-dxp.firebasestorage.app",
  messagingSenderId: "627186740877",
  appId: "1:627186740877:web:b0dae7828b883e8b3c3cc4",
  measurementId: "G-RGXXF5K2D6"
};
const BVVA = {
  postUrl: 'https://www.adquiramexico.com.mx/clb/endpoint/omicronlab',
  mpAccount: '12300'
};
const paypal = {
  clientId: 'AerwaNDF7ucBBjqGkhLd3GRYk3lVnsOguAuGMCmdbeGQod7RSNJtqtYAT90BW3c15OOnTNvlFJZ_rfYq'
};
const logoutUrl = 'dxp/home';
const fontsUrls = {
  frutiger: {
    bold: 'https://omicronsaprod.blob.core.windows.net/omicron-resources/Fonts/FrutigerNextBold.ttf',
    medium: 'https://omicronsaprod.blob.core.windows.net/omicron-resources/Fonts/FrutigerNextMedium.ttf',
    normal: 'https://omicronsaprod.blob.core.windows.net/omicron-resources/Fonts/FrutigerNextRegular.ttf'
  }
};
const featureFlags = {
  enableMSI: true,
};

export const environment: AppEnvironment = {
  production: true,
  theme: 'axity-theme',
  baseUrl: 'https://magistralesprod.omicronlab.com.mx',
  keycloak,
  conekta,
  loggerStrategy,
  firebase,
  paypal,
  BVVA,
  logoutUrl,
  fontsUrls,
  featureFlags,
   sentry: {
    dsn: 'https://2e37146685301f4e25835663987dbd6c@o4509357618233344.ingest.us.sentry.io/4511197245865984',
    environment: 'production',
    release: 'omicron-shop@1.0.0',
    tracePropagationTargets: [
      /^https:\/\/magistralesprod\.omicronlab\.com\.mx/
    ],
    tracesSampleRate: 1.0
  }
};

